<template>
  <div ref="table" class="h-full border flex flex-col" :style="`height: ${height}px;`">
    <div class="flex-1">
      <el-table v-fit-columns v-loading="loading" class="border-0" :data="data.list" stripe :height="height-32" :max-height="height-32">
        <el-table-column v-for="header in data.header" :key="header.tag" :prop="header.name" :label="header.title" />
      </el-table>
    </div>
    <div class="bg-white">
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, next, jumper"
        :total="data.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import zroute from '@/ziggy'

export default {
  name: 'DTable', // 这个名字很重要，它就是未来的标签名
  props: {
    height: {
      type: Number,
      default: 300,
    },
    width: {
      type: Number,
      default: 500,
    },
    // data: {
    //   type: Object,
    //   default: () => ({
    //     list: [],
    //     total: 0,
    //     header: [],
    //   }),
    // },
    query: {
      type: Object,
      default: () => ({
        page: 1,
        psize: 100,
      }),
    },
  },
  data() {
    return {
      loading: false,
      page: 1,
      // height: '',
      // listQuery: this.query,
      data: {
        list: [],
        total: 0,
        header: [],
      },
      listQuery: {},
    }
  },
  computed: {
  },
  watch: {
    height(val) {
      console.log('height changed', val)
    },
    listQuery: {
      deep: true,
      handler(val) {
        console.log('listQuery changed', val)
        this.getList()
      },
    },
    query: {
      handler(val) {
        this.listQuery = {...val, page: 1}
        console.log('query changed', val)
        // this.getList()
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // this.height = this.$refs.table.style.height
    console.log('DTable mounted', this.height)
  },
  methods: {
    current_change(page) {
      console.log('current_change', page)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.listQuery.page = val
    },
    getList() {
      this.loading = true
      axios.post(zroute('app.dash.list', [zroute().params.app_id, zroute().params.dash_id]), this.listQuery).then(res => {
        this.loading = false
        this.data = res.data
      })
    },
  },
}
</script>

<style lang="scss" scoped>
//去掉白线
::v-deep .el-table::before,.el-table::after {
  //display: none;
  z-index: 0;
}
</style>
